import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ActivityIcon, BrainIcon, CompassIcon } from 'lucide-react';
export function MechanismSection() {
  const phases = [{
    number: '①',
    title: 'REGULACIÓN',
    subtitle: 'Cuerpo',
    icon: <ActivityIcon className="w-7 h-7 text-sand" data-id="element-201" />,
    color: 'sand',
    borderColor: 'border-sand/40',
    hoverBorder: 'hover:border-sand/70',
    bgAccent: 'bg-sand/10',
    numberColor: 'text-sand',
    description: 'Energía estable, sueño profundo, comida real, movimiento diario.',
    detail: 'Cuando el cuerpo recibe señales de orden, el sistema nervioso se regula. La ansiedad baja. La energía se estabiliza.'
  }, {
    number: '②',
    title: 'CLARIDAD',
    subtitle: 'Mente',
    icon: <BrainIcon className="w-7 h-7 text-amber" data-id="element-202" />,
    color: 'amber',
    borderColor: 'border-amber/40',
    hoverBorder: 'hover:border-amber/70',
    bgAccent: 'bg-amber/10',
    numberColor: 'text-amber',
    description: 'Silencio mental, gratitud, observador, journaling.',
    detail: 'Cuando bajás el ruido interno, podés escucharte. Y cuando te escuchás, elegís distinto.'
  }, {
    number: '③',
    title: 'DIRECCIÓN',
    subtitle: 'Acción',
    icon: <CompassIcon className="w-7 h-7 text-offwhite" data-id="element-203" />,
    color: 'offwhite',
    borderColor: 'border-offwhite/20',
    hoverBorder: 'hover:border-offwhite/40',
    bgAccent: 'bg-offwhite/5',
    numberColor: 'text-offwhite',
    description: 'Identidad, hábitos sostenidos, propósito diario.',
    detail: 'Cuando sabés quién sos y qué querés, cada día tiene sentido. Los hábitos se sostienen solos.'
  }];
  return <section id="mechanism" className="py-10 md:py-32 bg-charcoal-dark border-y border-charcoal-light" data-id="element-204">
      <div className="max-w-5xl mx-auto px-6" data-id="element-205">
        <FadeIn className="text-center mb-12 md:mb-20" data-id="element-206">
          <p className="text-sm font-medium uppercase tracking-[0.2em] text-sand/70 mb-4" data-id="element-207">
            El sistema
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-offwhite mb-6" data-id="element-208">
            Método RESET
          </h2>
          <p className="text-lg text-offwhite-dim max-w-2xl mx-auto" data-id="element-209">
            3 fases que trabajan juntas. No una después de otra — las 3 al mismo
            tiempo, cada día.
          </p>
        </FadeIn>

        {/* Phase connector line - desktop only */}
        <div className="hidden md:block relative mb-4" data-id="element-210">
          <div className="absolute top-1/2 left-[16.66%] right-[16.66%] h-px bg-gradient-to-r from-sand/30 via-amber/30 to-offwhite/20" data-id="element-211"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-212">
          {phases.map((phase, idx) => <FadeIn key={idx} delay={idx * 0.15} direction="up" className={`bg-charcoal border ${phase.borderColor} ${phase.hoverBorder} p-8 md:p-10 rounded-sm transition-colors relative`} data-id="element-213">
              <div className="mb-6" data-id="element-214">
                <span className={`text-4xl font-heading font-bold ${phase.numberColor} opacity-80`} data-id="element-215">
                  {phase.number}
                </span>
              </div>

              <div className="flex items-center gap-3 mb-2" data-id="element-216">
                <div className={`${phase.bgAccent} p-2.5 rounded-sm`} data-id="element-217">
                  {phase.icon}
                </div>
                <div data-id="element-218">
                  <h3 className="text-xl font-heading font-bold text-offwhite tracking-wider" data-id="element-219">
                    {phase.title}
                  </h3>
                  <p className={`text-sm font-medium ${phase.numberColor} opacity-70 uppercase tracking-wider`} data-id="element-220">
                    {phase.subtitle}
                  </p>
                </div>
              </div>

              <p className="text-offwhite font-medium mt-6 mb-4 leading-relaxed" data-id="element-221">
                {phase.description}
              </p>

              <p className="text-offwhite-dim text-sm leading-relaxed" data-id="element-222">
                {phase.detail}
              </p>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} className="mt-12 md:mt-16 text-center" data-id="element-223">
          <p className="text-2xl font-heading font-bold text-sand" data-id="element-224">
            7 días. 30–45 minutos por día.
          </p>
          <p className="mt-3 text-lg text-offwhite-dim" data-id="element-225">
            Regulación + Claridad + Dirección ={' '}
            <span className="text-offwhite font-bold" data-id="element-226">control real.</span>
          </p>
        </FadeIn>
      </div>
    </section>;
}